import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api, ApiError } from "../lib/api";

const PAPER_SIZES = ["A4", "A3", "A2", "A1"] as const;
type PaperSize = (typeof PAPER_SIZES)[number];

export default function ExportMenu({ eventSessionId, colorMode }: { eventSessionId: number; colorMode: string }) {
  const { t, i18n } = useTranslation();
  const [paperSize, setPaperSize] = useState<PaperSize>("A3");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleExport() {
    setBusy(true);
    setError(null);
    try {
      const blob = await api.exportPdf({ eventSessionId, colorMode, paperSize, locale: i18n.language.split("-")[0] });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `hallenplan-${eventSessionId}-${paperSize}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Export failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="export-menu">
      <label>
        {t("hallPlan.exportFormat")}:{" "}
        <select value={paperSize} onChange={(e) => setPaperSize(e.target.value as PaperSize)}>
          {PAPER_SIZES.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </label>
      <button onClick={handleExport} disabled={busy}>
        {t("hallPlan.export")}
      </button>
      {error && <span className="error-text">{error}</span>}
    </div>
  );
}
